import styled from 'styled-components';

export const MatchHistoryContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 30px;
`;

export const TournamentBox = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
`;

export const MatchesBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 10px;
`;

export const TournamentTitle = styled.p`
    font-family: BlenderProBold, serif;
    font-size: 15px;
    color: grey;    
    align-self: center;
    text-align: center;
`;
